import DetailedRelatedContentWithVisibilityToggle from '@rsa-digital/evo-shared-components/components/RelatedContent/DetailedRelatedContentWithVisibilityToggle';
import { StyledCardGrid } from '@rsa-digital/evo-shared-components/components/RelatedContent/DetailedRelatedContentWithVisibilityToggle/styles';
import { CtaGrid } from '@rsa-digital/evo-shared-components/components/RelatedContent/styles';
import colors, {
  colorWithOpacity,
} from '@rsa-digital/evo-shared-components/helpers/colors';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled, { css } from 'styled-components';

const bottomPaddingSize = css`
  padding-bottom: ${spacing(3)};

  ${mediaQuery.tabletLandscape`
    padding-bottom: ${spacing(4)};
  `}
`;

export const StyledDetailedRelatedContentWithVisibilityToggle = styled(
  DetailedRelatedContentWithVisibilityToggle
)`
  margin-top: 0;

  h2 {
    margin-top: 0;
  }

  ${StyledCardGrid} {
    margin-bottom: 0;
  }
`;

export const DetailedRelatedContentContainer = styled.div<{
  hasCta?: boolean;
  displayBackground?: boolean;
}>`
  ${StyledDetailedRelatedContentWithVisibilityToggle} {
    padding-top: ${spacing(3)};

    ${mediaQuery.tabletLandscape`
      padding-top: ${spacing(4)};
    `}
  }

  ${({ hasCta }) =>
    !hasCta &&
    css`
      ${StyledDetailedRelatedContentWithVisibilityToggle} {
        ${bottomPaddingSize}
      }
    `}

  ${({ displayBackground }) =>
    displayBackground &&
    css`
      background-color: ${colorWithOpacity(colors.core01, 0.1)};

      /* takes background to full screen */
      margin: 0 calc(50% - 50vw) ${spacing(4)};
      /* resets the content back to the grid */
      padding: 0 calc(50vw - 50%);
      overflow: auto;
    `}
`;

export const StyledCtaGrid = styled(CtaGrid)`
  padding-top: ${spacing(2)};

  ${mediaQuery.tabletLandscape`
    padding-top: ${spacing(1)};
  `}

  ${bottomPaddingSize}
`;

export const CtaWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 0;
`;
